import LoyaltyProgressBar from './LoyaltyProgressBar'

export default LoyaltyProgressBar
export { LoyaltyProgressBar }
